import { NgModule } from '@angular/core';
import { LeftPanelComponent } from './left-panel.component';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { SiteModule } from '../../site/site.module';



@NgModule({
  declarations: [
    LeftPanelComponent,
  ],
  exports: [
    LeftPanelComponent,
  ],
  imports: [
    CommonModule,
    SiteModule,
    MatIconModule,
    TranslocoModule,
    MatTooltipModule,
    MatButtonModule
  ],
  providers: [

  ]
})
export class LeftPanelModule {}
